export const MainConfig = {
    // Ссылки на мобильные приложения
    appLink: {
        googlePlay: 'https://play.google.com/store/apps/details?id=ru.friend_mania',
        appStore:
            'https://apps.apple.com/ru/app/%D0%B4%D1%80%D1%83%D0%B3%D0%BE%D0%BC%D0%B0%D0%BD%D0%B8%D1%8F/id6743625540',
        apk: '/apk/friend-mania.apk',
    },
    metric: {
        yandex: {
            id: 100605144,
        },
    },
} as const;
